import React from 'react';
import Helmet from 'react-helmet';
import { FaEnvelope } from 'react-icons/lib/fa';

import Slide from 'react-reveal/Slide';
import AboutHeader from '../components/AboutHeader/AboutHeader';
import Container from '../components/Container/Container';
import Footer from '../components/Footer/Footer';
import config from '../../config/SiteConfig';
import styles from './about.module.scss';

const About = () => (
  <div className="container about-container">
    <Helmet title={`About Me | ${config.siteTitle}`} />
    <AboutHeader>Hi, I'm Rachael</AboutHeader>
    <Container text>
        <div className={styles.container}>
      <Slide bottom cascade wait={5000}>
          <p className={styles.received}>Hey Rach, how would you describe yourself?</p>
          <p className={styles.sent}>An overthinker with a biscuit problem.</p>
          <p className={styles.received}>I don't think that's what the people want to know.</p>
          <p className={styles.sent}>
            Okay, well, I’m an experienced writer, with ambitions to specialise in user experience. I’m endlessly
            curious, especially about people, psychology and behavioural economics. My writing style is relaxed and
            conversational. And I’m always up for a laugh.
          </p>
          <p className={styles.received}>
          How do you feel about bragging? 
          </p>
          <p className={styles.sent}>
          Not great.  
          </p>
          <p className={styles.received}>
          If you had to... for a bio?
          </p>
          <p className={styles.sent}>
            I got my{' '}
            <a href="/certifications" target="_blank" rel="noopener noreferrer">
              UX writer certification
            </a>{' '}
            in 2020 with the UX Writers Collective. I'm raising two gorgeous boys called Griffin and Miles, who are turning out quite well. I have an uncanny eye for typos (in other people's writing). And I bake a smashing vegan carrot cake. 
          </p>

          <p className={styles.buttonCentre}>
            <a href="mailto:hello@rach.nz" target="_blank" rel="noopener noreferrer">
              <FaEnvelope />Let's chat
            </a>
          </p>
      </Slide>
        </div>
    </Container>
    <Footer />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.jsx